/*
 * usage: ${color.primary[600]}
 */
export const color = {
  common: {
    white: '#fff',
    black: '#0D141A',
    neutral: '#f5f6f9',
    transparent: 'transparent',
    lightBlue: '#F7FCFC',
    cardDarkGradient: 'linear-gradient(180deg, #00395E 0%, #001828 100%)',
    midnightTeal: '#0D314A',
  },
  primary: {
    25: '#FFF5F7',
    50: '#ffeaee',
    100: '#ffcbd1',
    200: '#f79796',
    300: '#ef6d6d',
    400: '#fa4947',
    500: '#ff3429',
    600: '#f02729',
    700: '#de1824',
    800: '#d10a1c',
    900: '#c3000c',
    1000: '#AF000B',
  },
  darkBlue: {
    25: '#F2F6FC',
    50: '#E3EBF7',
    100: '#BECEDC',
    200: '#9AACBE',
    300: '#768BA1',
    400: '#5C748C',
    500: '#415E78',
    600: '#355168',
    700: '#273F53',
    800: '#192D3E',
    900: '#081A28',
    1000: '#071621',
  },
  steel: {
    25: '#F0F8FA',
    50: '#E0F3F7',
    100: '#B1E0EB',
    200: '#81CBDF',
    300: '#50B7D5',
    400: '#1AA9D1',
    500: '#009BCE',
    600: '#008EC1',
    700: '#007CB0',
    800: '#006B9D',
    900: '#004D7F',
    1000: '#003659',
  },
  blue: {
    25: '#F2FAFF',
    50: '#E3F4FF',
    100: '#BBE2FF',
    200: '#8DD0FF',
    300: '#56BDFF',
    400: '#1DADFF',
    500: '#009EFF',
    600: '#008FFF',
    700: '#007BFF',
    800: '#1269EC',
    900: '#1F47CD',
    1000: '#07268F',
  },
  yellow: {
    25: '#FEFDF6',
    50: '#FEFCE7',
    100: '#FCF8C4',
    200: '#FBF39E',
    300: '#F9EE78',
    400: '#F7E95A',
    500: '#F5E43E',
    600: '#F5D43B',
    700: '#F3BD33',
    800: '#F0A52B',
    900: '#EB7E1D',
    1000: '#BD5B04',
  },
  green: {
    25: '#F2FAF5',
    50: '#e4f6ea',
    100: '#bfe8ca',
    200: '#94d9a9',
    300: '#64cb86',
    400: '#37c06c',
    500: '#00b451',
    600: '#00a547',
    700: '#00933b',
    800: '#008230',
    900: '#00621c',
    1000: '#004213',
  },
  darkGrey: {
    25: '#FCFEFF',
    50: '#F6F9FA',
    100: '#EEF1F2',
    200: '#E4E7E8',
    300: '#E4E7E8',
    400: '#AFB2B3',
    500: '#8F9293',
    600: '#676A6B',
    700: '#545657',
    800: '#363839',
    900: '#161819',
  },
  mediumGrey: {
    25: '#FAFAFA',
    50: '#EFF0F2',
    100: '#D7DBE1',
    200: '#BCC3CD',
    300: '#A1ABB9',
    400: '#8C98A9',
    500: '#778699',
    600: '#697688',
    700: '#586270',
    800: '#484F5A',
    900: '#343A42',
  },
  grey: {
    25: '#FCFCFD',
    50: '#F9FAFB',
    100: '#F2F4F7',
    200: '#EAECF0',
    300: '#D0D5DD',
    400: '#98A2B3',
    500: '#667085',
    600: '#475467',
    700: '#334054',
    800: '#1D2939',
    900: '#101828',
  },
  midnight: {
    25: '#F7FAFF',
    50: '#deebff',
    100: '#b6cdf6',
    200: '#8cadea',
    300: '#668edc',
    400: '#5378d3',
    500: '#4763c7',
    600: '#4656b9',
    700: '#4246a6',
    800: '#3d3592',
    900: '#331371',
    1000: '#1E054D',
  },
};
